module.exports = __webpack_public_path__ + "static/img/ent-1.7c30f59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-1.jpg
// module id = aHIw
// module chunks = 52